import Component from '../core/Component'
import { STATES as NAV_STATES } from './PopupNav'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class PopupNavOpener extends Component {

    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on('nav-close', this.handleNavClose)
    }

    destroy() {
        EventBus.off('nav-close', this.handleNavClose)
    }

    handleClick = event => {
        event.preventDefault()

        const id = this.element.hash.replace('#','') 

        const nav = Component.getFromElement(id)

        if (!nav) {
            return
        }

        nav.toggle()

        if (nav.is(NAV_STATES.ACTIVE)) {
            this.element.classList.add(STATES.ACTIVE)
        } else {
            this.element.classList.remove(STATES.ACTIVE)
        }
    }

    handleNavClose = () => {
        this.element.classList.remove(STATES.ACTIVE)
    }
}